import React from "react";
import Button from "../Button";
import { Categories as CategoriesType } from "../../store/actions/types";

import * as S from "./style";

interface CategoriesProps {
  categories: CategoriesType;
}

const Categories: React.FC<CategoriesProps> = ({ categories }) => {
  const renderCategories = categories
    .filter(
      (category) => category["@id"] !== "https://unitiva.it/cms/case-study"
    )
    .map((category, i) => {
      const id = category["@id"].split("/").pop();

      return (
        <Button
          key={id && id + i}
          className={`btn btn-${id}`}
          asLink
          path={`/${id}`}
        >
          {category.title}
        </Button>
      );
    });

  return (
    <S.CategoriesWrapper>
      <h6>Filtra per categorie</h6>
      {renderCategories}
    </S.CategoriesWrapper>
  );
};

export default Categories;
